import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { ROUTE_WE_SPIN } from '../../../router/constants.js';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import { subscribeToAdNotifications } from '../ducks/we-spin-duck.js';
import useTranslations from '~/components/translation/use-translations';
import { WE_SPIN_NOTIFICATION_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import useUIContext from '../../../../ui/use-ui-context';

/**
 * Send a message to players in the Casino or in the WeSpin lobby telling them that a session is about to start.
 *
 */

const useWeSpinAdNotifications = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const { showSidebar } = useUIContext();
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_NOTIFICATION_TEXT_KEYS);
	const isAuthenticated = useSelector(authenticationSelector);
	const { ROUTE_CASINO } = useCasinoRoutes();

	const isPlayerOnAllowedRoute =
		location.pathname.startsWith(ROUTE_CASINO) || location.pathname.startsWith(ROUTE_WE_SPIN);

	useEffect(() => {
		const notificationData = {
			showSidebar,
			buttonLinkTo: ROUTE_WE_SPIN,
			buttonText: `${tr.WE_SPIN_NOTIFICATION_BUTTON_TEXT}`,
			messageTextFirst: `${tr.WE_SPIN_NOTIFICATION_MESSAGE_1}`,
			messageTextSecond: `${tr.WE_SPIN_NOTIFICATION_MESSAGE_2}`
		};

		if (!isLoadingTranslations && isPlayerOnAllowedRoute && isAuthenticated) {
			const cancel = subscribeToAdNotifications(dispatch, notificationData);
			return () => cancel();
		}
	}, [
		dispatch,
		isLoadingTranslations,
		isPlayerOnAllowedRoute,
		isAuthenticated,
		showSidebar,
		tr.WE_SPIN_NOTIFICATION_BUTTON_TEXT,
		tr.WE_SPIN_NOTIFICATION_MESSAGE_1,
		tr.WE_SPIN_NOTIFICATION_MESSAGE_2
	]);
};

const WeSpinNotificationClient = () => {
	useWeSpinAdNotifications();
	return null;
};

export default WeSpinNotificationClient;
